const iconBaseUrl = "https://tourismus.ulm.de/api/icons/";
const iconsFolderUrl = "/assets/poi-categories/";

export const getIconUrl = (iconUrl) => {
  if (!iconUrl) {
    return `${iconsFolderUrl}default-icon.svg`;
  }

  if (!!iconUrl) {
    return `${iconUrl}`;
  }

  return `${iconsFolderUrl}default-icon.svg`;
};

export default iconBaseUrl;
